import {Link45deg} from "react-bootstrap-icons";
import c from './invoice.module.css';

export const columnsTable = (openLabelingModal) => {
    return [
        {
            dataField: 'issue_date',
            text: 'Issue Date',
            headerStyle: (colum, colIndex) => {
                return {width: '140px', textAlign: 'center', verticalAlign: 'middle'};
            }
        }, {
            dataField: 'invoice_number',
            text: 'Invoice Number',
            classes: () => 'overFlowHiddenRow',
            headerStyle: (colum, colIndex) => {
                return {width:'300px',textAlign: 'center', overflow: 'hidden', verticalAlign: 'middle'};
            }
        }, {
            dataField: 'price',
            text: 'Price',
            classes: () => c.numeric,
            headerStyle: () => ({width: '100px', textAlign: 'right', verticalAlign: 'middle'}),
            formatter: (cell) => (cell || cell === 0) ? `${cell} USD` : '—',
        },  {
            dataField: 'status',
            text: 'Status',
            classes: () => 'reportFileCenter',
            headerStyle: () => ({width: '120px', textAlign: 'center', verticalAlign: 'middle'}),
            // 'Paid' and 'Activated' as plain text read as data rather than state
            formatter: (cell) => {
                const tone = cell === 'Activated' ? c.badgeActive
                    : cell === 'Paid' ? c.badgePaid : c.badgeNeutral;
                return <span className={`${c.badge} ${tone}`}>{cell}</span>;
            },
        },
        {
            dataField: 'url',
            text: 'Invoice',
            classes: () => 'reportFileCenter',
            headerStyle: (colum, colIndex) => {
                return {width: '80px', textAlign: 'center', verticalAlign: 'middle'};
            },
            formatter: (cell, row) => {
                return <a style={{fontSize: '16px', whiteSpace: 'nowrap'}}
                          aria-hidden="true"
                          rel="noreferrer"
                          target='_blank'
                          title={cell}
                          href={cell}><Link45deg size={20}/> View </a>
            },
        },
    ];
}
